import _ from "lodash";

const convertStatusToLetter = function(status) {
  return _.get({
    0: '',
    1: 'A',
    2: 'B',
    3: 'C',
  }, status);
};

export default {
  state: {
    isCohabiting: false,
  },
  getters: {
    Config: (state, getters, rootState) => rootState.config,

    cohabitingKey: (state) => state.isCohabiting ? 'cohabiting' : 'single',

    targetIncome: (state, getters) => {
      if (getters.areInputsValid === false) {
        return 0;
      }

      const keys = Object.keys(getters.answers);

      let totalValue = 0;
      keys.forEach((key) => {
        const answerLetter = convertStatusToLetter(getters.answers[key]);
        totalValue += getters.Config.targetIncomes[getters.cohabitingKey][key][answerLetter];
      });

      return totalValue * 52.2;
    },

    maxValueForStandard: (state, getters) => (standardLetterKey) => {
      const keys = Object.keys(getters.answers);
      let totalValue = 0;

      keys.forEach((key) => {
        totalValue += getters.Config.targetIncomes[getters.cohabitingKey][key][standardLetterKey];
      });

      return totalValue * 52.2;
    },

    standards: (state, getters) => {
      return {
        minimum: {
          text: 'age pension',
          maxValue: getters.maxValueForStandard('A'),
        },
        moderate: {
          text: 'modest',
          maxValue: getters.maxValueForStandard('B'),
        },
        comfortable: {
          text: 'comfortable',
          maxValue: getters.maxValueForStandard('C'),
        }
      };
    },

    standardChosen: (state, getters) => {
      const { standards, targetIncome } = getters

      if (targetIncome <= standards.minimum.maxValue) {
        return standards.minimum.text;

      } else if (targetIncome <= standards.moderate.maxValue) {
        return standards.moderate.text;

      } else if (targetIncome <= standards.comfortable.maxValue) {
        return standards.comfortable.text;
      }
    },
  },
  mutations: {
    selectIsCohabiting(state, isCohabiting) {
      state.isCohabiting = isCohabiting;
    },
  },
};
